import { createAction, createReducer, PayloadAction } from '@reduxjs/toolkit'
import { ImportDocumentFormData } from 'src/helpers/importDocumentFormValidation'

export interface InitialImportDocumentValues {
  motorbike_id: number
  motorbike_name: string
  import_date: string
  with_plates: boolean
}

export interface ImportDocumentReducer {
  loading: boolean
  error: string | null
  import_document_pdf: string | null
  initialImportDocumentValues: Record<string, InitialImportDocumentValues>
}

const initialState: ImportDocumentReducer = {
  loading: false,
  error: null,
  import_document_pdf: null,
  initialImportDocumentValues: {}
}

export type CreateImportDocumentActionType = PayloadAction<ImportDocumentFormData>
export const CREATE_IMPORT_DOCUMENT = createAction<ImportDocumentFormData>(
  'import_document_reducer/create_import_document'
)

interface CreateImportDocumentSuccessPayload {
  pdf_url: string
}

export const CREATE_IMPORT_DOCUMENT_SUCCESS = createAction<CreateImportDocumentSuccessPayload>(
  'import_document_reducer/create_import_document_success'
)
export const CREATE_IMPORT_DOCUMENT_FAILURE = createAction('import_document_reducer/create_import_document_failure')

export const RESET_IMPORT_DOCUMENT_PDF = createAction('import_document_reducer/reset_import_document_pdf')

interface FetchInitialImportDocumentValuesPayload {
  id: string
}

export type FetchInitialImportDocumentValuesActionType = PayloadAction<FetchInitialImportDocumentValuesPayload>

export const FETCH_INITIAL_IMPORT_DOCUMENT_VALUES = createAction<FetchInitialImportDocumentValuesPayload>(
  'import_document_reducer/fetch_initial_import_document_values'
)

interface FetchInitialImportDocumentValuesSuccessPayload extends InitialImportDocumentValues {
  id: string
}

export const FETCH_INITIAL_IMPORT_DOCUMENT_VALUES_SUCCESS =
  createAction<FetchInitialImportDocumentValuesSuccessPayload>(
    'import_document_reducer/fetch_initial_import_document_values_success'
  )

export const FETCH_INITIAL_IMPORT_DOCUMENT_VALUES_FAILURE = createAction(
  'import_document_reducer/fetch_initial_import_document_values_failure'
)

// Update Import Document Actions
interface UpdateImportDocumentPayload {
  values: ImportDocumentFormData
  id: string
}

export type UpdateImportDocumentActionType = PayloadAction<UpdateImportDocumentPayload>

export const UPDATE_IMPORT_DOCUMENT = createAction<UpdateImportDocumentPayload>(
  'import_document_reducer/update_import_document'
)

export const UPDATE_IMPORT_DOCUMENT_SUCCESS = createAction<CreateImportDocumentSuccessPayload>(
  'import_document_reducer/update_import_document_success'
)

export const UPDATE_IMPORT_DOCUMENT_FAILURE = createAction('import_document_reducer/update_import_document_failure')

export const importDocumentReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(CREATE_IMPORT_DOCUMENT, (state) => {
      state.loading = true
      state.error = null
    })
    .addCase(CREATE_IMPORT_DOCUMENT_SUCCESS, (state, action) => {
      state.loading = false
      state.import_document_pdf = action.payload.pdf_url
      state.error = null
    })
    .addCase(CREATE_IMPORT_DOCUMENT_FAILURE, (state, action) => {
      state.loading = false
    })
    .addCase(RESET_IMPORT_DOCUMENT_PDF, (state) => {
      state.import_document_pdf = null
    })
    .addCase(FETCH_INITIAL_IMPORT_DOCUMENT_VALUES, (state) => {
      state.loading = true
    })
    .addCase(FETCH_INITIAL_IMPORT_DOCUMENT_VALUES_SUCCESS, (state, action) => {
      state.loading = false
      state.initialImportDocumentValues[action.payload.id.toString()] = action.payload
    })
    .addCase(FETCH_INITIAL_IMPORT_DOCUMENT_VALUES_FAILURE, (state) => {
      state.loading = false
    })
    .addCase(UPDATE_IMPORT_DOCUMENT, (state) => {
      state.loading = true
    })
    .addCase(UPDATE_IMPORT_DOCUMENT_SUCCESS, (state, action) => {
      state.import_document_pdf = action.payload.pdf_url
      state.loading = false
    })
    .addCase(UPDATE_IMPORT_DOCUMENT_FAILURE, (state) => {
      state.loading = false
    })
})
